import * as React from "react";
import Layouts from "../../components/Layouts";
import { Row, Col, Card, Button } from "antd";
import HomeInsurancePolicy from "../../components/grid/HomeInsurancePolicy";
import ColumnOffset from "../../components/grid/ColumnOffset";
import GridGutter from "../../components/grid/GridGutter";
import FlexLayout from "../../components/grid/FlexLayout";
import FlexAlignment from "../../components/grid/FlexAlignment";
import WrappedEditQuotation from "../../components/grid/EditQuotation";
class editquotation extends React.Component {
  render() {
    return (
      <Layouts title="assets" classname="grid">
        <Row gutter={16}>
          <Col xs={24} lg={24}>
            <Card bordered={false} bodyStyle={{ padding: "0 20px 20px" }}>
              <WrappedEditQuotation />
            </Card>
          </Col>
        </Row>
      </Layouts>
    );
  }
}

export default editquotation;
